import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import React, { useState } from "react";
import "./PaySchedule.css";

const PaySchedule = () => {
    const { id: businessId } = useParams();
    const [frequency, setFrequency] = useState("");
    const [startDay, setStartDay] = useState("");
    const [payday, setPayday] = useState("");
    const [options, setOptions] = useState([]); // Stores selectable pay periods
    const [selectedPeriod, setSelectedPeriod] = useState(null); // Stores the selected pay period
    const [showSubmit, setShowSubmit] = useState(true); // Controls visibility of the Submit button
    const [showInputs, setShowInputs] = useState(true); // Controls visibility of frequency and input selections
    const navigate = useNavigate();
    const daysOfWeek = {
        sunday: 0,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6,
    };

    const formatDateWithDay = (date) => {
        const day = date.getDate();
        const month = date.getMonth() + 1; // Months are zero-based
        const year = date.getFullYear();
        const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
        return {
            date: `${month}/${day}/${year}`,
            day: dayOfWeek,
        };
    };

    const formatDateToMySQL = (date) => {
        const [month, day, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    };
    

    const handleSubmit = async () => {
        const data = {
            startDate: formatDateToMySQL(selectedPeriod.startDate.date), // Convert to YYYY-MM-DD
            endDate: formatDateToMySQL(selectedPeriod.endDate.date),
            payDate: formatDateToMySQL(selectedPeriod.payDate.date),
            frequency,
            frequencyEnteredOn: new Date().toISOString().split("T")[0], // Current timestamp
        };
    
        try {
            const response = await api.put(`/business/${businessId}/set-pay-period`, data);
            alert(response.data); // Success message
            navigate(`/dashboard/business/${businessId}/start-payroll`);
        } catch (error) {
            console.error("Error updating pay period:", error);
            alert("Failed to update pay period.");
        }
    };
    

    const calculateDates = () => {
        if (!frequency || !payday) return;

        const today = new Date();

        if (frequency === "weekly" || frequency === "biweekly") {
            const shiftBackDays = frequency === "weekly" ? 7 : 7;
            const currentDay = today.getDay();
            const daysUntilStartDay =
                (currentDay - daysOfWeek[startDay] + (frequency === "weekly" ? 7 : 14)) %
                (frequency === "weekly" ? 7 : 14);

            const startDate = new Date(today);
            startDate.setDate(today.getDate() - daysUntilStartDay);

            const endDate = new Date(startDate);
            endDate.setDate(startDate.getDate() + (frequency === "weekly" ? 6 : 13));

            const payDate = new Date(endDate);
            payDate.setDate(endDate.getDate() + parseInt(payday));


                // Previous period (shifted back)
            const prevStartDate = new Date(startDate);
            prevStartDate.setDate(startDate.getDate() - shiftBackDays);

            const prevEndDate = new Date(endDate);
            prevEndDate.setDate(endDate.getDate() - shiftBackDays);

            const prevPayDate = new Date(payDate);
            prevPayDate.setDate(payDate.getDate() - shiftBackDays);


            // Set selectable options (Current & Previous)
            setOptions([
                {
                    label: `Current Period: ${formatDateWithDay(startDate).date} - ${formatDateWithDay(endDate).date}`,
                    startDate,
                    endDate,
                    payDate,
                },
                {
                    label: `Previous Period: ${formatDateWithDay(prevStartDate).date} - ${formatDateWithDay(prevEndDate).date}`,
                    startDate: prevStartDate,
                    endDate: prevEndDate,
                    payDate: prevPayDate,
                }
            ]);

            // setSelectedPeriod({
            //     startDate: formatDateWithDay(startDate),
            //     endDate: formatDateWithDay(endDate),
            //     payDate: formatDateWithDay(payDate),
            // });
        } else if (frequency === "monthly") {
            const currentStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
            const currentEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

            const previousStartDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            const previousEndDate = new Date(today.getFullYear(), today.getMonth(), 0);

            setOptions([
                {
                    label: `Current Month: ${formatDateWithDay(currentStartDate).date} - ${formatDateWithDay(
                        currentEndDate
                    ).date}`,
                    startDate: currentStartDate,
                    endDate: currentEndDate,
                },
                {
                    label: `Previous Month: ${formatDateWithDay(previousStartDate).date} - ${formatDateWithDay(
                        previousEndDate
                    ).date}`,
                    startDate: previousStartDate,
                    endDate: previousEndDate,
                },
            ]);
        } else if (frequency === "semimonthly") {
            const currentStartDate =
                today.getDate() <= 15
                    ? new Date(today.getFullYear(), today.getMonth(), 1)
                    : new Date(today.getFullYear(), today.getMonth(), 16);
            const currentEndDate =
                today.getDate() <= 15
                    ? new Date(today.getFullYear(), today.getMonth(), 15)
                    : new Date(today.getFullYear(), today.getMonth() + 1, 0);

            const previousStartDate =
                today.getDate() <= 15
                    ? new Date(today.getFullYear(), today.getMonth() - 1, 16)
                    : new Date(today.getFullYear(), today.getMonth(), 1);
            const previousEndDate =
                today.getDate() <= 15
                    ? new Date(today.getFullYear(), today.getMonth(), 0)
                    : new Date(today.getFullYear(), today.getMonth(), 15);

            setOptions([
                {
                    label: `Current Period: ${formatDateWithDay(currentStartDate).date} - ${formatDateWithDay(
                        currentEndDate
                    ).date}`,
                    startDate: currentStartDate,
                    endDate: currentEndDate,
                },
                {
                    label: `Previous Period: ${formatDateWithDay(previousStartDate).date} - ${formatDateWithDay(
                        previousEndDate
                    ).date}`,
                    startDate: previousStartDate,
                    endDate: previousEndDate,
                },
            ]);
        }

        setShowSubmit(false); // Hide Submit button
        setShowInputs(false); // Hide selection inputs
    };

    const handlePeriodSelection = (period) => {
        setSelectedPeriod({
            startDate: formatDateWithDay(period.startDate),
            endDate: formatDateWithDay(period.endDate),
            payDate: formatDateWithDay(
                new Date(period.endDate.getTime() + parseInt(payday) * 24 * 60 * 60 * 1000)
            ),
        });
    };

    const resetDates = () => {
        setFrequency("");
        setStartDay("");
        setPayday("");
        setOptions([]);
        setSelectedPeriod(null);
        setShowSubmit(true); // Show Submit button
        setShowInputs(true); // Show selection inputs
    };

    const isSubmitVisible = () => {
        if (!frequency || !payday) return false;
        if (frequency === "weekly" || frequency === "biweekly") {
            return !!startDay;
        }
        return true;
    };

    return (
        <div className="pay-period-container">
            <h2 className="pay-period-title">Pay Schedule</h2>

            {showInputs && (
                <>
                    <select
                        className="pay-period-select"
                        value={frequency}
                        onChange={(e) => {
                            setFrequency(e.target.value);
                            setOptions([]);
                            setSelectedPeriod(null);
                        }}
                    >
                        <option value="" disabled>
                            Select Frequency
                        </option>
                        <option value="weekly">Weekly</option>
                        <option value="biweekly">Biweekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="semimonthly">Semi-Monthly</option>
                    </select>

                    {(frequency === "weekly" || frequency === "biweekly") && (
                        <select
                            className="pay-period-select"
                            value={startDay}
                            onChange={(e) => setStartDay(e.target.value)}                          
                        >
                            <option value="" disabled>
                                Select Start Day
                            </option>
                            {Object.keys(daysOfWeek).map((day) => (
                                <option key={day} value={day}>
                                    {day.charAt(0).toUpperCase() + day.slice(1)}
                                </option>
                            ))}
                        </select>
                    )}

                    {frequency && (
                        <input
                            className="pay-period-input"
                            type="number"
                            value={payday}
                            onChange={(e) => setPayday(e.target.value)}
                            placeholder="Enter days after end date"
                            
                        />
                    )}
                </>
            )}

            {isSubmitVisible() && showSubmit && (
                <button
                    style={{
                        backgroundColor: "#4caf50",
                        color: "white",
                        padding: "10px 15px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        marginTop: "15px",
                        width: "100%",
                    }}
                    onClick={calculateDates}
                >
                    Submit
                </button>
            )}

            {options.length > 0 && (
                <div style={{ marginTop: "15px" }}>
                    <h3>Pay Period Options:</h3>
                    {options.map((option, index) => (
                        <button
                            key={index}
                            style={{
                                display: "block",
                                margin: "10px 0",
                                padding: "10px",
                                backgroundColor: "#007bff",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                            }}
                            onClick={() => handlePeriodSelection(option)}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
            )}

            {selectedPeriod && (
                <div>
                <p><strong>Frequency:</strong> {frequency.charAt(0).toUpperCase() + frequency.slice(1)}</p>
                <p><strong>Business Id</strong> {businessId}</p>
                <div style={{ marginTop: "80px", display: "flex", justifyContent: "space-between", gap: "10px" }}>
            {["startDate", "endDate", "payDate"].map((key, index) => {
                // Define unique styles for each key
                const containerStyles = {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    backgroundColor: key === "startDate" ? "white" : key === "endDate" ? "white" : "white",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    padding: "15px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    width: "100px",
                    textAlign: "center",
                };

                const labelStyles = {
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: key === "startDate" ? "red" : key === "endDate" ? "blue" : "green",
                    marginBottom: "5px",
                };

                const dayStyles = {
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: key === "startDate" ? "red" : key === "endDate" ? "blue" : "green",
                };

                const dateStyles = {
                    fontSize: "13px",
                    color: "#555",
                    fontWeight: "bold",
                };

                return (
                    <div key={index} style={containerStyles}>
                        <div style={labelStyles}>
                            {key === "startDate" ? "Start" : key === "endDate" ? "End" : "Pay"}
                        </div>
                        <div style={dayStyles}>{selectedPeriod[key].day}</div>
                        <div style={dateStyles}>{selectedPeriod[key].date}</div>
                    </div>
                );
            })}
        </div>
                    <div style={{ marginTop: "60px", display: "flex", justifyContent: "center", gap: "10px" }}>
                        <button
                            style={{
                                backgroundColor: "#1b2034",
                                color: "white",
                                padding: "10px 15px",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                            }}
                            onClick={handleSubmit}
                        >
                            Set Payroll Date
                        </button>
                        <button
                            style={{
                                backgroundColor: "#f44336",
                                color: "white",
                                padding: "10px 15px",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                            }}
                            onClick={resetDates}
                        >
                            Reset Shown Dates
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PaySchedule;





// import React, { useState } from "react";

// const PaySchedule = () => {
//     const [frequency, setFrequency] = useState("");
//     const [startDay, setStartDay] = useState("sunday");
//     const [payday, setPayday] = useState("");
//     const [options, setOptions] = useState([]); // Stores selectable pay periods
//     const [selectedPeriod, setSelectedPeriod] = useState(null); // Stores the selected pay period
//     const [showSubmit, setShowSubmit] = useState(true); // Controls visibility of the Submit button
//     const [showInputs, setShowInputs] = useState(true); // Controls visibility of frequency and input selections

//     const daysOfWeek = {
//         sunday: 0,
//         monday: 1,
//         tuesday: 2,
//         wednesday: 3,
//         thursday: 4,
//         friday: 5,
//         saturday: 6,
//     };

//     const formatDateWithDay = (date) => {
//         const day = date.getDate();
//         const month = date.getMonth() + 1; // Months are zero-based
//         const year = date.getFullYear();
//         const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
//         return {
//             date: `${month}/${day}/${year}`,
//             day: dayOfWeek,
//         };
//     };

//     const calculateDates = () => {
//         if (!frequency || !payday) return;

//         const today = new Date();

//         if (frequency === "weekly" || frequency === "biweekly") {
//             const currentDay = today.getDay();
//             const daysUntilStartDay =
//                 (currentDay - daysOfWeek[startDay] + (frequency === "weekly" ? 7 : 14)) %
//                 (frequency === "weekly" ? 7 : 14);

//             const startDate = new Date(today);
//             startDate.setDate(today.getDate() - daysUntilStartDay);

//             const endDate = new Date(startDate);
//             endDate.setDate(startDate.getDate() + (frequency === "weekly" ? 6 : 13));

//             const payDate = new Date(endDate);
//             payDate.setDate(endDate.getDate() + parseInt(payday));

//             setSelectedPeriod({
//                 startDate: formatDateWithDay(startDate),
//                 endDate: formatDateWithDay(endDate),
//                 payDate: formatDateWithDay(payDate),
//             });
//         } else if (frequency === "monthly") {
//             const currentStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
//             const currentEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

//             const previousStartDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
//             const previousEndDate = new Date(today.getFullYear(), today.getMonth(), 0);

//             setOptions([
//                 {
//                     label: `Current Month: ${formatDateWithDay(currentStartDate).date} - ${formatDateWithDay(
//                         currentEndDate
//                     ).date}`,
//                     startDate: currentStartDate,
//                     endDate: currentEndDate,
//                 },
//                 {
//                     label: `Previous Month: ${formatDateWithDay(previousStartDate).date} - ${formatDateWithDay(
//                         previousEndDate
//                     ).date}`,
//                     startDate: previousStartDate,
//                     endDate: previousEndDate,
//                 },
//             ]);
//         } else if (frequency === "semimonthly") {
//             const currentStartDate =
//                 today.getDate() <= 15
//                     ? new Date(today.getFullYear(), today.getMonth(), 1)
//                     : new Date(today.getFullYear(), today.getMonth(), 16);
//             const currentEndDate =
//                 today.getDate() <= 15
//                     ? new Date(today.getFullYear(), today.getMonth(), 15)
//                     : new Date(today.getFullYear(), today.getMonth() + 1, 0);

//             const previousStartDate =
//                 today.getDate() <= 15
//                     ? new Date(today.getFullYear(), today.getMonth() - 1, 16)
//                     : new Date(today.getFullYear(), today.getMonth(), 1);
//             const previousEndDate =
//                 today.getDate() <= 15
//                     ? new Date(today.getFullYear(), today.getMonth(), 0)
//                     : new Date(today.getFullYear(), today.getMonth(), 15);

//             setOptions([
//                 {
//                     label: `Current Period: ${formatDateWithDay(currentStartDate).date} - ${formatDateWithDay(
//                         currentEndDate
//                     ).date}`,
//                     startDate: currentStartDate,
//                     endDate: currentEndDate,
//                 },
//                 {
//                     label: `Previous Period: ${formatDateWithDay(previousStartDate).date} - ${formatDateWithDay(
//                         previousEndDate
//                     ).date}`,
//                     startDate: previousStartDate,
//                     endDate: previousEndDate,
//                 },
//             ]);
//         }

//         setShowSubmit(false); // Hide Submit button
//         setShowInputs(false); // Hide selection inputs
//     };

//     const handlePeriodSelection = (period) => {
//         setSelectedPeriod({
//             startDate: formatDateWithDay(period.startDate),
//             endDate: formatDateWithDay(period.endDate),
//             payDate: formatDateWithDay(
//                 new Date(period.endDate.getTime() + parseInt(payday) * 24 * 60 * 60 * 1000)
//             ),
//         });
//     };

//     const resetDates = () => {
//         setFrequency("");
//         setStartDay("sunday");
//         setPayday("");
//         setOptions([]);
//         setSelectedPeriod(null);
//         setShowSubmit(true); // Show Submit button
//         setShowInputs(true); // Show selection inputs
//     };

//     const isSubmitVisible = () => {
//         if (!frequency || !payday) return false;
//         if (frequency === "weekly" || frequency === "biweekly") {
//             return !!startDay;
//         }
//         return true;
//     };

//     return (
//         <div style={{ fontFamily: "Arial, sans-serif", maxWidth: "400px", margin: "20px auto" }}>
//             <h2 style={{textAlign:"center", marginTop:"30px"}}>Set Pay Period</h2>

//             {showInputs && (
//                 <>
//                     <label style={{display:"flex", fontWeight:"bold", marginLeft:"17%", marginTop:"40px"}}>
//                         Select Frequency:
//                         <select
//                             value={frequency}
//                             onChange={(e) => {
//                                 setFrequency(e.target.value);
//                                 setOptions([]);
//                                 setSelectedPeriod(null);
//                             }}
//                         >
//                             <option value="">Select Frequency</option>
//                             <option value="weekly">Weekly</option>
//                             <option value="biweekly">Biweekly</option>
//                             <option value="monthly">Monthly</option>
//                             <option value="semimonthly">Semi-Monthly</option>
//                         </select>
//                     </label>

//                     {(frequency === "weekly" || frequency === "biweekly") && (
//                         <label style={{fontWeight:"bold", display:"flex", marginLeft:"6%", marginTop:"35px"}}>
//                             Day of the Week Pay Period Starts:
//                             <select
//                                 value={startDay}
//                                 onChange={(e) => setStartDay(e.target.value)}
//                             >
//                                 {Object.keys(daysOfWeek).map((day) => (
//                                     <option key={day} value={day}>
//                                         {day.charAt(0).toUpperCase() + day.slice(1)}
//                                     </option>
//                                 ))}
//                             </select>
//                         </label>
//                     )}

//                     {frequency && (
//                         <label>
//                             Pay Date (number of days after pay period ends):
//                             <input
//                                 type="number"
//                                 value={payday}
//                                 onChange={(e) => setPayday(e.target.value)}
//                                 placeholder="Enter number of days"
//                             />
//                         </label>
//                     )}
//                 </>
//             )}

//             {isSubmitVisible() && showSubmit && (
//                 <button
//                     style={{
//                         backgroundColor: "#4caf50",
//                         color: "white",
//                         padding: "10px 15px",
//                         border: "none",
//                         borderRadius: "5px",
//                         cursor: "pointer",
//                         marginTop: "15px",
//                     }}
//                     onClick={calculateDates}
//                 >
//                     Submit
//                 </button>
//             )}

//             {options.length > 0 && (
//                 <div style={{ marginTop: "15px" }}>
//                     <h3>Pay Period Options:</h3>
//                     {options.map((option, index) => (
//                         <button
//                             key={index}
//                             style={{
//                                 display: "block",
//                                 margin: "10px 0",
//                                 padding: "10px",
//                                 backgroundColor: "#007bff",
//                                 color: "white",
//                                 border: "none",
//                                 borderRadius: "5px",
//                                 cursor: "pointer",
//                             }}
//                             onClick={() => handlePeriodSelection(option)}
//                         >
//                             {option.label}
//                         </button>
//                     ))}
//                 </div>
//             )}

//             {selectedPeriod && (
//                 <div>
//                     <div style={{ marginTop: "15px", display: "flex", justifyContent: "space-between", gap: "10px" }}>
//                         {["startDate", "endDate", "payDate"].map((key, index) => (
//                             <div
//                                 key={index}
//                                 style={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     alignItems: "center",
//                                     backgroundColor: "#f3f4f6",
//                                     border: "1px solid #ddd",
//                                     borderRadius: "8px",
//                                     padding: "15px",
//                                     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//                                     width: "100px",
//                                     textAlign: "center",
//                                 }}
//                             >
//                                 <div
//                                     style={{
//                                         fontSize: "14px",
//                                         fontWeight: "bold",
//                                         color: "#333",
//                                         marginBottom: "5px",
//                                     }}
//                                 >
//                                     {key === "startDate"
//                                         ? "Start"
//                                         : key === "endDate"
//                                         ? "End"
//                                         : "Pay"}
//                                 </div>
//                                 <div
//                                     style={{
//                                         fontSize: "18px",
//                                         fontWeight: "bold",
//                                         color: "#4caf50",
//                                     }}
//                                 >
//                                     {selectedPeriod[key].day}
//                                 </div>
//                                 <div
//                                     style={{
//                                         fontSize: "12px",
//                                         color: "#555",
//                                     }}
//                                 >
//                                     {selectedPeriod[key].date}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                     <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "10px" }}>
//                         <button
//                             style={{
//                                 backgroundColor: "#4caf50",
//                                 color: "white",
//                                 padding: "10px 15px",
//                                 border: "none",
//                                 borderRadius: "5px",
//                                 cursor: "pointer",
//                             }}
//                             onClick={() => alert("Set payroll date functionality here.")}
//                         >
//                             Set Payroll Date
//                         </button>
//                         <button
//                             style={{
//                                 backgroundColor: "#f44336",
//                                 color: "white",
//                                 padding: "10px 15px",
//                                 border: "none",
//                                 borderRadius: "5px",
//                                 cursor: "pointer",
//                             }}
//                             onClick={resetDates}
//                         >
//                             Reset Shown Dates
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default PaySchedule;










